'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Modal from 'react-modal';

import PlanEditor from '@components/Plans/Editor.react';
import PlanCard from "@components/Dashboard/FeaturedPlans/PlanCard.react";
import UserStore from '@stores/UserStore';
import AuthStore from '@stores/AuthStore';
import { getConfig } from '@utils/Env';

import './Viewer.scss';

export default class Viewer extends Component {

    static contextTypes = {
        isPro: PropTypes.bool,
        showLoginForm: PropTypes.func,
        confirm: PropTypes.func,
        router: PropTypes.object,
        isMobile: PropTypes.bool,
        isCordova: PropTypes.bool,
    };

    constructor(props, context) {
        super(props, context);

        const user = UserStore.getUser();

        if (!user) {
            this.loadPlan(props.params.uuid)
        }

        this.state = {
            user,
            plan: null,
            loading: true,
        };
    }

    componentDidMount = () => {
        const { params } = this.props
        const { user } = this.state;
        const { isPro, confirm } = this.context;

        UserStore.addChangeListener(this.onUserStoreChange);

        if (user && user.dietitian && !isPro) {
            // Use the PRO customizer route; the bare /menus/{uuid} route renders this same
            // shared Viewer and would loop on the sign-in modal if the PRO session is absent.
            const proUrl = 'https://' + getConfig('pro_host') + '/menus/' + params.uuid + '/customize';

            confirm(
                <p className="t3">We noticed you have both an EatLove PRO account and client account.  Would you like to open this using your PRO account?</p>,
                accept => window.open(proUrl, '_blank'),
                reject => false,
                {acceptText: 'Yes, go to EatLove PRO', rejectText: 'No, use my client account'}
            );
        }
    }

    componentWillUnmount = () => {
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onUserStoreChange = () => {
        this.setState({
            user: UserStore.getUser()
        });
    }

    loadPlan = (uuid) => {
             AuthStore.fetch(getConfig('recipe_api') + '/plans/' + uuid + '?embed=assets', null, true).then(
                plan => {
                    this.setState({plan, loading: false})
                },
                error => {
                    this.setState({loading: false, isModalOpen: true});
                }
            );
    }


    onClickSignIn = () => {
        const { showLoginForm } = this.context;

        showLoginForm();
        this.closeModal();
    }

    closeModal = () => {
        this.setState({isModalOpen: false});
    }

    renderSignInModal = () => {
        const { params } = this.props;
        const { isModalOpen } = this.state;

        if (!isModalOpen) {
            return;
        }

        // Point at the PRO customizer route, not /menus/{uuid}: the bare route renders this
        // same shared Viewer, so a logged-out visitor would just get this sign-in modal again
        // (an endless loop). /customize renders the PRO Customizer, which shows a real PRO
        // login for logged-out users and the plan once signed in.
        const proUrl = 'https://' + getConfig('pro_host') + '/menus/' + params.uuid + '/customize';
        const consumerUrl = 'https://' + getConfig('self_host') + '/menus/' + params.uuid;

        return (
            <Modal isOpen={true}
                className="el-modal el-modal3 el-modal3-fixed"
                overlayClassName="el-modal-overlay"
                onRequestClose={this.closeModal}
                closeModal={this.closeModal}
                contentLabel="Open Collection"
                closeTimeoutMS={250}>
                <div className="el-modal-container el-modal3-container collection-sign-in-modal ">
                    <header>
                        <h2>Sign in to view the plan</h2>
                    </header>
                    <footer>
                        <a className="el-medium-btn el-medium-btn el-raspberry-btn" onClick={this.onClickSignIn}>Sign In EatLove</a>
                        <a className="el-medium-btn el-medium-btn el-raspberry-outline-btn" target="_blank" href={proUrl} >Sign In EatLove PRO (for professionals)</a>
                    </footer>
                </div>
            </Modal>
        );
    }


    renderPlanPreview = () => {
        const { plan, loading } = this.state;


        return (
            <div data-loading={loading} className="patient-recommend-plans" >
                {loading ? <div className="loading"><p>loading...</p><i className="icon-spinner2" /></div> : null}
                {plan ?
                    (<div className="new-plan-mode">

                        <div className="plan-title">
                            <h3 onClick={() => this.setState({isModalOpen: true})}>{plan.title}</h3>
                            <button className="el-medium-btn el-medium-wide-btn el-raspberry-btn" onClick={() => this.setState({isModalOpen: true})}>VIEW THE PLAN</button>
                        </div>

                        <PlanCard  onClick={() => this.setState({isModalOpen: true})} plan={plan} hideTitle={true} showAdvancedMode={false} />
                    </div>)
                : null}
            </div>
        )
    }

    render = () => {
        const { isPro, showLoginForm, confirm, router, isMobile, isCordova } = this.context;
        const { params, location } = this.props;
        const { user } = this.state;

        return (
            <div className="customizer-page">
                {!isPro ? <Link to="/">
                    <img className="eatlove-logo-header" src="https://static.chewba.info/images/header-logo-gray-green-2017-07-03.png" />
                </Link> : null}
                {user ? <PlanEditor uuid={params.uuid}
                    location={location}
                    hideWarnings={isPro}
                    firstRun={location && location.query && location.query.signup ? true : false}
                    showAddToPlanner={true}
                    showConsumerFavoriteButton={true}
                    router={router}
                    confirm={confirm}
                    isPro={isPro}
                    isMobile={isMobile}
                    isCordova={isCordova}
                    showLoginForm={showLoginForm} />
                : this.renderPlanPreview()}
                {this.renderSignInModal()}
            </div>
        );
    }
}
